import { DateFieldUI } from '@axo/form/feature/form-input/DateField/DateFieldUI';
import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { TextFieldUI } from '@axo/form/feature/form-input/TextField/TextFieldUI';
import { EmploymentStatus } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { Text } from '@axo/ui-core/components/typography';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useBroker } from '../../../../../../../hooks/useBroker';
import { CoApplicantEmploymentData } from '../../../../../FormData.fi.types';
import { employmentOptions } from '../../../../config/globals';
import { gridColumns } from '../../../../config/layouts/grid';
import styles from '../../../../loan.module.scss';
import {
  coApplicantEmployerFieldOption,
  coApplicantEmploymentStatusFieldOption,
  coApplicantEmploymentStatusSinceFieldOption,
} from './config';

export const CoApplicantEmployment = () => {
  const { t } = useTranslation();

  const broker = useBroker();

  const { watch } = useFormContext();

  const currentYear = new Date().getFullYear();

  const employmentStatus = watch('LoanApplication/CoApplicantEmploymentStatus');

  const askEmploymentDetails = useMemo(
    () =>
      [
        EmploymentStatus.Permanent,
        EmploymentStatus.Temporary,
        EmploymentStatus.Entrepreneur,
      ].includes(employmentStatus),
    [employmentStatus]
  );

  return (
    <>
      <Text>
        <b>{t('AddCoApplicant.CoApplicantEmployment')}</b>
      </Text>
      <Grid columns={gridColumns}>
        <DropdownFieldUI<CoApplicantEmploymentData>
          name="LoanApplication/CoApplicantEmploymentStatus"
          label={t('CoApplicantEmploymentStatus.label')}
          data-testid="employment-status-input"
          options={employmentOptions[broker]}
          {...coApplicantEmploymentStatusFieldOption}
        />

        {askEmploymentDetails && (
          <>
            <TextFieldUI<CoApplicantEmploymentData>
              name="LoanApplication/CoApplicantEmployer"
              label={t('CoApplicantEmployer.label')}
              data-testid="employer-input"
              {...coApplicantEmployerFieldOption}
            />

            {/* TODO: Fix styles DateFieldUI */}
            <div className={styles.dateFieldUI}>
              <DateFieldUI<CoApplicantEmploymentData>
                name="LoanApplication/CoApplicantEmploymentStatusSince"
                label={t('EmploymentStatusSince.label', {
                  employmentStatus: t(`EmploymentStatus.${employmentStatus}`),
                })}
                data-testid="employment-status-since-input"
                minYear={currentYear - 10}
                maxYear={currentYear}
                disableDatesInFuture
                minYearSuffix={t('EmploymentStatusSince.year.suffix')}
                yearPlaceholder={t('EmploymentStatusSince.placeholder.year')}
                monthPlaceholder={t('EmploymentStatusSince.placeholder.month')}
                latestYearAtTop={true}
                i18n="fi-FI"
                rules={
                  coApplicantEmploymentStatusSinceFieldOption.registerOptions
                }
              />
            </div>
          </>
        )}
      </Grid>
    </>
  );
};
